import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMail: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 3.121V15h16V3.121l-8 8z\"/><path fill=\"currentColor\" d=\"M16 1H0l8 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMail
